import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import GrantsHub from "@/pages/GrantsHub";

export const Route = createFileRoute("/grants/")({
  head: () => seoHead("/grants"),
  component: GrantsHub,
});
